export class MoleculeError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'MoleculeError';
  }
}
